import type { IChartLine } from "./buildChartLines";
import { Y_AXIS_MAX, Y_AXIS_MIN } from "./constants";

export interface IYAxisRange {
  min: number;
  max: number;
}

const FULL_RANGE: IYAxisRange = { min: Y_AXIS_MIN, max: Y_AXIS_MAX };

const MIN_PADDING = 2;

const PADDING_RATIO = 0.15;

const isNumber = (value: number | null): value is number => value !== null;

export const getYAxisRange = (
  lines: IChartLine[],
  autoscale: boolean
): IYAxisRange => {
  if (!autoscale) {
    return FULL_RANGE;
  }

  const values = lines.flatMap(({ data }) => data).filter(isNumber);

  if (!values.length) {
    return FULL_RANGE;
  }

  const dataMin = Math.min(...values);
  const dataMax = Math.max(...values);
  const padding = Math.max((dataMax - dataMin) * PADDING_RATIO, MIN_PADDING);

  return {
    min: Math.max(Y_AXIS_MIN, dataMin - padding),
    max: Math.min(Y_AXIS_MAX, dataMax + padding),
  };
};
